

const _data = {
  single_entry_value: 'n',
  amtDecimalPlace: '2',
  userName: ''
};

function init(values) {
  _data.single_entry_value = values.single_entry_value
  _data.amtDecimalPlace = values.amtDecimalPlace
  _data.userName = values.userName
  Object.freeze(_data);
}
const AccParamACL = {
  init: values => init(values),
  atFetch: () => _data,
}

Object.freeze(AccParamACL);
export default AccParamACL;